var render = function (_h,_vm) {var _c=_vm._c;return _c('a',{class:[("c-base-link-external " + (_vm.props.variant ? ("c-base-link-external--" + (_vm.props.variant)) : '') + " " + (_vm.data.staticClass || ''))],attrs:{"href":_vm.props.link,"target":_vm.props.target}},[_vm._v(" "+_vm._s(_vm.props.content)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }